import { enTypeToastNotificationMessage } from "interface/toastNotification";

export const toastSuccess = (message: string) => ({
  type: 'RECEIVE_MSG',
  message,
  typeMessage: enTypeToastNotificationMessage.SUCCESS
});

export const toastError = (message: string) => ({
  type: 'RECEIVE_MSG',
  message,
  typeMessage: enTypeToastNotificationMessage.ERROR
});

export const removeMsg = (id: string) => ({
  type: 'CLEAN_MSG',
  id
});

export const removeMessage = (id: string) => async (dispatch: any) => {
  dispatch(removeMsg(id));
};
